"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Template_1 = __importDefault(require("../Template"));

var Input_1 = __importDefault(require("./Input"));

var Select_1 = __importDefault(require("./Select"));

var Textarea_1 = __importDefault(require("./Textarea"));

var DataFieldRender = function DataFieldRender(props) {
  var className = props.className,
      componentType = props.componentType,
      fieldProps = props.fieldProps,
      handleOnChange = props.handleOnChange,
      handleOnBlur = props.handleOnBlur,
      id = props.id,
      input = props.input,
      templateProps = props.templateProps;

  var newInput = _objectSpread({}, input);

  var onChange = input.onChange,
      onBlur = input.onBlur;

  if (handleOnChange) {
    newInput.onChange = function (event) {
      handleOnChange({
        event: event,
        name: input.name
      });
      onChange(event);
    };
  }

  if (handleOnBlur) {
    newInput.onBlur = function (event) {
      var value = event.currentTarget.value;
      handleOnBlur({
        event: event,
        value: value,
        name: input.name
      });
      onBlur(event);
    };
  }

  if ('hidden' === componentType) {
    return react_1.default.createElement("input", _objectSpread(_objectSpread({}, input), {}, {
      type: "hidden"
    }));
  }

  var Component;

  switch (componentType) {
    case 'input':
      {
        Component = react_1.default.createElement(Input_1.default, _objectSpread(_objectSpread(_objectSpread({}, props), fieldProps), {}, {
          className: className,
          input: newInput
        }));
        break;
      }

    case 'select':
      {
        Component = react_1.default.createElement(Select_1.default, _objectSpread(_objectSpread(_objectSpread({}, props), fieldProps), {}, {
          className: className,
          input: newInput
        }));
        break;
      }

    case 'textarea':
      {
        Component = react_1.default.createElement(Textarea_1.default, _objectSpread(_objectSpread(_objectSpread({}, props), fieldProps), {}, {
          className: className,
          input: newInput
        }));
        break;
      }

    default:
      return react_1.default.createElement("div", null, "data field render : erreur de param\xE8tre : ".concat(componentType, " n'est pas pris en charge"));
  }

  return react_1.default.createElement(Template_1.default, _objectSpread(_objectSpread({
    id: id
  }, props), templateProps), Component);
};

exports.default = DataFieldRender;